import { ActionType } from "../action-types"
import { UserRole, AppState, SideMenuState, TrainingState, NavState, InventoryStateChange, InventoryValueChange, LoadingStateChange } from "../../models"
import { Dispatch } from "redux"
import { UpdateRoleAction, UpdateAppStateAction, UpdateSideMenuStateAction, UpdateTrainingStateAction, ClearTrainingStateAction, UpdateNavStateAction, ClearNavStateAction, UpdateInventoryStateAction, UpdateInventoryTypeStateAction, UpdateLoadingStateAction } from "../actions"

export const updateRole = (role: UserRole) => {
    return (dispatch: Dispatch<UpdateRoleAction>) => {
        dispatch({
            type: ActionType.UpdateRole,
            payload: role
        })
    }
}

export const updateAppState = (appState: AppState) => {
    return (dispatch: Dispatch<UpdateAppStateAction>) => {
        dispatch({
            type: ActionType.UpdateAppState,
            payload: appState
        })
    }
}

export const updateSideMenuState = (sideMenuState: SideMenuState) => {
    return (dispatch: Dispatch<UpdateSideMenuStateAction>) => {
        dispatch({
            type: ActionType.UpdateSideMenu,
            payload: sideMenuState
        })
    }
}

export const updateNavState = (navState: NavState) => {
    return (dispatch: Dispatch<UpdateNavStateAction>) => {
        dispatch({
            type: ActionType.UpdateNavState,
            payload: navState
        })
    }
}

export const clearNavState = () => {
    return (dispatch: Dispatch<ClearNavStateAction>) => {
        dispatch({
            type: ActionType.ClearNavStack
        })
    }
}

export const updateTrainingState = (training: TrainingState) => {
    return (dispatch: Dispatch<UpdateTrainingStateAction>) => {
        dispatch({
            type: ActionType.UpdateTrainingState,
            payload: training
        })
    }
}

export const clearTrainingState = () => {
    return (dispatch: Dispatch<ClearTrainingStateAction>) => {
        dispatch({
            type: ActionType.ClearTrainingState
        })
    }
}

export const updateInventoryState = (inventory: InventoryValueChange) => {
    return (dispatch: Dispatch<UpdateInventoryStateAction>) => {
        dispatch({
            type: ActionType.UpdateInventory,
            payload: inventory
        })
    }
}

export const updateInventoryTypeState = (inventory: InventoryStateChange) => {
    return (dispatch: Dispatch<UpdateInventoryTypeStateAction>) => {
        dispatch({
            type: ActionType.UpdateInventoryType,
            payload: inventory
        })
    }
}

export const updateLoadingState = (loadingState: LoadingStateChange) => {
    return (dispatch: Dispatch<UpdateLoadingStateAction>) => {
        dispatch({
            type: ActionType.UpdateLoading,
            payload: loadingState
        })
    }
}